<template>
	<div class="columns is-vcentered">
		<div class="column py-2 is-1">
			<p class="ap-cell ap-cell--num has-text-right">{{ index + 1 }}.-</p>
		</div>
		<div class="column py-2 is-2">
			<p class="ap-cell ap-cell--strong">{{ item.level_1 }}</p>
		</div>
		<div class="column py-2 is-3">
			<p class="ap-cell">{{ item.level_2 }}</p>
		</div>
		<div class="column py-2 is-4">
			<p class="ap-cell">{{ item.level_3 }}</p>
		</div>
		<div class="column py-2 is-1">
			<span class="tag is-rounded is-primary">{{ item.order }}</span>
		</div>
		<div class="column py-2 is-1 ap-ops">
			<button type="button" class="ap-icon-btn" @click="$emit('edit-account')">
				<EditPencil />
			</button>
			<button type="button" class="ap-icon-btn" @click="$emit('delete-account')">
				<Trash />
			</button>
		</div>
	</div>
</template>

<script>
import EditPencil from "@/components/svg/EditPencil";
import Trash from "@/components/svg/Trash";

export default {
	name: "AccountPlanRow",
	components: {
		EditPencil,
		Trash,
	},
	props: {
		item: {
			type: Object,
			required: true,
		},
		index: {
			type: Number,
			required: true,
		},
	},
};
</script>
<style scoped lang="scss">
.ap-cell {
	font-size: 1rem;
	color: var(--ap-ink-2);

	&--strong {
		font-weight: 600;
		color: var(--ap-ink);
	}

	&--num {
		font-weight: 600;
		font-variant-numeric: tabular-nums;
	}
}

.tag.is-primary {
	background-color: var(--ap-teal-wash);
	color: var(--ap-teal-deep);
	font-weight: 700;
	font-variant-numeric: tabular-nums;
}

// ── Operaciones (iconos) ────────────────────────────────────────────────
.ap-ops {
	display: flex;
	gap: 0.375rem;
}

.ap-icon-btn {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 5px 8px;
	background: transparent;
	border: 1px solid var(--ap-line);
	border-radius: var(--ap-radius-sm);
	color: var(--ap-slate);
	cursor: pointer;
	transition: color 0.18s var(--ap-ease), border-color 0.18s var(--ap-ease);

	&:hover {
		color: var(--ap-teal);
		border-color: var(--ap-teal);
	}

	&:focus-visible {
		outline: 2px solid var(--ap-teal);
		outline-offset: 2px;
	}
}
</style>
